/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StorageHeaterUIDTOV0 { 
    /**
     * The number of storage heaters with this index number.
     */
    numberOfHeaters?: number;
    /**
     * The index number of the heater from the product database.
     */
    indexNumber?: number;
    /**
     * Whether heater is high heat retention type.
     */
    highHeatRetention?: boolean;
}

